// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file catpocs/v1/roles.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import { RoleService } from "./roles_pb";

/**
 * GetCurrentUser retrieves the current user's information
 *
 * @generated from rpc catpocs.v1.RoleService.GetCurrentUser
 */
export const getCurrentUser = RoleService.method.getCurrentUser;

/**
 * GetUserPermissions retrieves permissions for a user in a project
 *
 * @generated from rpc catpocs.v1.RoleService.GetUserPermissions
 */
export const getUserPermissions = RoleService.method.getUserPermissions;

/**
 * ListSuperAdmins lists all super admins
 *
 * @generated from rpc catpocs.v1.RoleService.ListSuperAdmins
 */
export const listSuperAdmins = RoleService.method.listSuperAdmins;

/**
 * AddSuperAdmin adds a super admin (super admin only)
 *
 * @generated from rpc catpocs.v1.RoleService.AddSuperAdmin
 */
export const addSuperAdmin = RoleService.method.addSuperAdmin;

/**
 * RemoveSuperAdmin removes a super admin (super admin only)
 *
 * @generated from rpc catpocs.v1.RoleService.RemoveSuperAdmin
 */
export const removeSuperAdmin = RoleService.method.removeSuperAdmin;
